import { Controller } from "@hotwired/stimulus";
import { httpRequest } from "../http";

export default class extends Controller {
  static values = {
    uploadUrl: String,
  };

  static targets = ["loading", "fileInput", "overrideWarning"];

  fileUploading = false;

  openModal() {
    this.element.classList.remove("hidden");
    this.element.classList.add("flex");

    // Show the data override warning if there are existing payroll entries
    if (document.querySelectorAll("[data-payroll-entry]").length > 0) {
      this.overrideWarningTarget.classList.remove("hidden");
    } else {
      this.overrideWarningTarget.classList.add("hidden");
    }
  }

  closeModal() {
    if (this.fileUploading) {
      return;
    }

    this.element.classList.remove("flex");
    this.element.classList.add("hidden");
  }

  onFileSelected(event) {
    this.fileUploading = true;

    const fileInput = event.target;
    const file = fileInput.files[0];

    this.fileInputTarget.disabled = true;
    this.fileInputTarget.classList.add("hidden");
    this.loadingTarget.classList.remove("hidden");

    const formData = new FormData();
    formData.append("file", file);

    httpRequest(this.uploadUrlValue, {
      method: "POST",
      body: formData,
    })
      // Just reload the page, we'll have a upload state banner there
      .then(() => window.location.reload())
      .catch(() => {
        this.fileUploading = false;
        this.fileInputTarget.value = null;
        this.fileInputTarget.disabled = false;
        this.fileInputTarget.classList.remove("hidden");
        this.loadingTarget.classList.add("hidden");
        alert("File upload failed. Please try again.");
      });
  }
}
